import React, { useEffect } from "react";
import { init } from "@emailjs/browser";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PolitiqueDeConfidentialite from "./pages/PolitiqueDeConfidentialite";
import MentionsLegales from "./pages/MentionsLegales";
import NotFound from "./pages/NotFound";
import ComingSoon from "./pages/ComingSoon";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./hooks/useScrollToTop";
import { LanguageProvider, useLang } from "./context/LanguageContext";
import "./styles/main.scss";

// Set to false to take the site live; while true every URL shows the
// full-screen "coming soon" page with no header or footer.
const COMING_SOON = true;

const LangSync = () => {
  const { lang } = useLang();
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return null;
};

function App() {
  useEffect(() => {
    init("cjiWH7cMxX1WSg_Zr");
  }, []);

  if (COMING_SOON) {
    return <ComingSoon />;
  }

  return (
    <LanguageProvider>
      <LangSync />
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueDeConfidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    </LanguageProvider>
  );
}

export default App;
